import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

/**
 * Agrega un documento a la liquidación usando el endpoint correspondiente.
 * @param oidDocumento - Identificador del documento a agregar
 * @returns Promesa con la respuesta del backend
 */
export const addDocumentOnSettlement = async (
  oidDocumento: number | string
): Promise<unknown> => {
  try {
    const res = await apiClient.post(Endpoints.AgregarLiquidacionDocumentos, {
      oidDocumento,
    });
    return res.data;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
